import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Register from "./Register";
import AccountProvider from '../contexts/Account'
import { HotelProvider } from "../contexts/Hotels/HotelProvider";
import Layout from '../layout'
import HomePage from "./Home";
import Destination from "./Destination";
import DestinationDeatil from "./Destination/DestinationDetail";
import Endow from "./Endow";
import FeedBack from "./FeedBack";
import Experiences from "./Experiences";
import Hotel from "./Hotel";
import HotelDetail from "./Hotel/HotelDetail";
import Media from "./Media";
import AboutUs from "./AboutUs";
import NewsDestail from "./NewsDetail";
import Contact from "./Contact";
import FAQS from "./FAQS";
import Policy from "./Policy";
import Profile from './Profile'
import MyBooking from "./MyBooking";
import PersonalDocument from "./PersonalDocument";
import Bills from "./Bills";
import PrivateRoute from './PrivateRoute'
import BookingSearch from "./BookingSearch";
import { SearchProvider, SearchDateProvider } from '../contexts/Search'
function App() {
  return (
    <>
      <div className="wrapper">
      <Providers>
        <Router>
            <Switch>
              <Route exact path="/register" component={Register} />
              <Route exact path={"/booking"} component={BookingSearch} />
              <Layout>
                <Route exact path="/" component={HomePage} />
                <Route exact path="/destination" component={Destination} />
                <Route path="/destination/:id/:hastag?" component={DestinationDeatil} />
                <Route exact path="/endow" component={Endow} />
                <Route exact path="/feedback" component={FeedBack} />
                <Route exact path="/experiences" component={Experiences} />
                <Route exact path="/hotel" component={Hotel} />
                <Route path="/hotel/:id" component={HotelDetail} />
                <Route exact path="/media" component={Media} />
                <Route path="/about-us/:source?" component={AboutUs} />
                <Route path="/login=:name" component={HomePage} />
                <Route path="/news/:id" component={NewsDestail} />
                <Route path="/contact" component={Contact} />
                <Route path="/faqs/:faq?" component={FAQS} />
                <Route path="/policy/:poli?" component={Policy} />
                <PrivateRoute exact path="/profile" component={Profile} />
                <PrivateRoute exact path="/my-booking" component={MyBooking} />
                <PrivateRoute exact path="/profile/my-booking" component={MyBooking} />
                <PrivateRoute exact path="/profile/personal-document" component={PersonalDocument} />
                <PrivateRoute exact path="/profile/bill" component={Bills} />
                <Route exact path="/404" component={() => "404 NOT FOUND"} />
              </Layout>
            </Switch>
        </Router>
      </Providers>
      </div>
    </>
  );
}

const Providers = ({ children }) => {
  return (
    <AccountProvider>
      <HotelProvider>
        <SearchProvider>
          <SearchDateProvider>
            <>
              {children}
            </>
          </SearchDateProvider>
        </SearchProvider>
      </HotelProvider>

    </AccountProvider>
  );
};
export default App;





